import { createApi } from '@reduxjs/toolkit/query/react';
import { AuditEntityType, AuditLogDto, IPagedCollection } from '@sr/dto';
import { createBaseQuery } from 'shared/api/rtk-query';

export type AuditLogsQuery = {
  entityType: AuditEntityType;
  entityId: number;
  page?: number;
  itemsPerPage?: number;
};

export const auditApi = createApi({
  reducerPath: 'auditApi',
  baseQuery: createBaseQuery(),
  tagTypes: ['AuditLog'],
  endpoints: (builder) => ({
    getAuditLogs: builder.query<IPagedCollection<AuditLogDto>, AuditLogsQuery>({
      query: ({ entityType, entityId, page = 0, itemsPerPage = 20 }) => ({
        url: `/audit/${entityType}/${entityId}`,
        params: {
          page,
          itemsPerPage,
        },
      }),
      providesTags: (result, error, arg) => [{ type: 'AuditLog', id: `${arg.entityType}-${arg.entityId}` }],
    }),
  }),
});

export const { useGetAuditLogsQuery } = auditApi;
